var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRulesIconsRulesScoring = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 14.07 14.95",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:.75px;}.b,.c{stroke:#fba91d;stroke-linecap:round;stroke-linejoin:round;}.c{fill:#fba91d;stroke-width:.73px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.33,14.52l-2.39-1.35c-.15-.08-.33-.07-.47,0l-2.33,1.33c-.37,.21-.81-.11-.75-.54l.4-2.72c.02-.17-.03-.34-.15-.46l-1.94-1.88c-.31-.3-.15-.83,.26-.9l2.62-.45c.17-.03,.31-.14,.38-.3l1.13-2.49c.18-.39,.72-.41,.91-.02l1.22,2.44c.08,.15,.22,.26,.39,.28l2.64,.34c.42,.05,.59,.58,.3,.89l-1.87,1.96c-.12,.12-.17,.3-.14,.47l.51,2.82c.08,.43-.35,.76-.73,.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.95,.38V5.37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.53,2.87H.38"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRulesIconsRulesScoring, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RulesIcons_Rules_Scoring.61e09062.svg";
export { ForwardRef as ReactComponent };